// AccessDenied.js
import React from "react";
import "./AccessDenied.css"; // Create this file for the CSS (shown below)

const AccessDenied = () => {
  return (
    <div className="access-denied-container">
      <div className="access-denied-card">
        <div className="access-denied-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
          </svg>
        </div>
        <h2 className="access-denied-title">Access Denied</h2>
        <p className="access-denied-message">
          Only user with student account has access to manage this page.
        </p>
        <p className="access-denied-contact">
          Please contact your administrator if you believe this is an error.
        </p>
        <button
          className="access-denied-button"
          onClick={() => {
            if (window.history.length > 1) {
              window.history.back();
            } else {
              // Fallback: Redirect to home or a safe route
              window.location.href = "/";
            }
          }}
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

export default AccessDenied;
